import home from './home';
import working from './working';
import features from './features';
import products from './products';
import terms from './terms';
import recipe from './recipe';
import health from './health';

export default { home, working, features, products, terms, recipe, health };
